import React from 'react';
import { Snackbar, Alert, Button } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { useVersionCheck } from '@/shared/lib/useVersionCheck';

export function UpdateAvailableSnackbar(): React.ReactNode {
  const { t } = useTranslation();
  const { updateAvailable } = useVersionCheck();

  if (!updateAvailable) return null;

  return (
    <Snackbar open anchorOrigin={{ vertical: 'bottom', horizontal: 'right' }}>
      <Alert
        severity="info"
        variant="filled"
        action={
          <Button
            color="inherit"
            size="small"
            onClick={() => window.location.reload()}
          >
            {t('corepilot.app.updateAvailable.cta')}
          </Button>
        }
      >
        {t('corepilot.app.updateAvailable.title')}
      </Alert>
    </Snackbar>
  );
}
